<template>
  <div class="app-container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="应付明细" name="one" style="">
        <tabYF v-if="activeName=='one'"></tabYF>
      </el-tab-pane>
      <!-- <el-tab-pane label="付款风控反馈" name="three">
        <fengkongfankui v-if="activeName=='three'"></fengkongfankui>
      </el-tab-pane> -->
      <el-tab-pane label="账单管理" name="two">
        <tabYFZDGL v-if="activeName=='two'"></tabYFZDGL>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import tabYF from '@/views/newTMS/transportation/caiWuManage/yingFuSettlement/tabYF.vue'
import tabYFZDGL from '@/views/newTMS/transportation/caiWuManage/yingFuSettlement/tabYFZDGL.vue'
import fengkongfankui from '@/views/newTMS/transportation/caiWuManage/yingFuSettlement/fengkongfankui.vue'
export default {
  components: {
    tabYF,
    tabYFZDGL,
    fengkongfankui
  },
  data () {
    return {
      activeName: 'one'
    }
  },
  created () {
    if (this.$route.query.ZDFlag) {
      this.activeName = 'two'
    } else {
      this.activeName = 'one'
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/YFZDdetils') {
      to.meta.isBack = true
    } else {
      to.meta.isBack = false
    }
    next()
  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin: 0;
}
</style>
